export default {
  SET_BRAND(state, payload) {
    state.logo = payload.logo_url;
    state.color_1 = payload.color_1;
    state.color_2 = payload.color_2;
    state.color_3 = payload.color_3;
    state.plan = payload.plan;
  },
};
